import Die from "./Die"
import d1 from './img/1.svg'
import d2 from './img/2.svg'
import d3 from './img/3.svg'
import d4 from './img/4.svg'
import d5 from './img/5.svg'
import d6 from './img/6.svg'

export default () => ({
    customDice: false,
    customPanelOpen: false,
    customSets: [],
    dice: [],
    pipImages: [d1,d2,d3,d4,d5,d6],
    faces: [1, 2, 3, 4, 5, 6],
    init() {
        this.numDice = 5
        this.getCustomSets()
    },
    get numDice() { return this.dice.length },
    set numDice(val) {
        const next = Math.max(0, parseInt(val, 10) || 0)
        if(next > this.dice.length){
            this.addDie()
            this.numDice = next
        }else{
        if (next < this.dice.length){
            this.removeDie();
            this.numDice = next
            }
        }
    },
    get numFaces() { return this.faces.length },
    set numFaces(val) {
        const next = Math.max(1, parseInt(val, 10) || 0)
        this.faces = []
        for (let i = 0; i < next; i++) {
            this.faces.push(i + 1)
        }
    },
    get numHeldDice() { return this.numDice - this.freeDice.length },
    get freeDice() { return this.dice.filter(die => !die.held) },
    get facingDice() { return this.dice.map(die => die.face).sort() },
    get facingTotal() { return this.dice.map(die => parseInt(die.face)).reduce((a, b) => a + b, 0) },
    addDie() { this.dice.push(new Die(this.faces)) },
    removeDie() { this.dice.pop()},
    addFace(text = this.faces.length+1) {this.faces.push(text)},
    removeFace(index = -1) {this.faces.splice(index,1)},
    resetFaces() {
        this.faces.forEach((face, i) => { this.faces[i] = i + 1 })
        this.dice.forEach(die => die.roll(this.faces))
    },
    toggleCustomDice() {
        if (this.customDice && this.customPanelOpen) {
            this.customDice = false
            this.customPanelOpen = false
            this.resetFaces()
            return
        }
        if (this.customDice && !this.customPanelOpen) {
            this.customPanelOpen = true
            return
        }
        this.customDice = true
        this.customPanelOpen = true
    },
    closeCustomPanel() {
        this.customPanelOpen = false
    },
    // READ AND WRITE SETS TO LOCAL STORAgE
    addCustomSet(inputName) {
        // Check if name exists
        let i = this.customSets.map(set => set.name).indexOf(inputName)
        if (i >= 0) {
            if (confirm('Would you like to overwrite the exising set with that name? \nIf not, cancel and choose a different name') == true) {
                this.customSets[i] = { name: inputName, list: [...this.faces] }
                localStorage.setItem('customSets', JSON.stringify(this.customSets))
                this.getCustomSets()
            }
        } else {
            this.customSets.push({ name: inputName, list: [...this.faces] })
            localStorage.setItem('customSets', JSON.stringify(this.customSets))
            this.getCustomSets()
        }
        this.setName = ''
    },
    getCustomSets() {
        try {
            this.customSets = JSON.parse(localStorage.getItem('customSets')) || []
        } catch (error) {
            this.customSets = []
            localStorage.removeItem('customSets')
        }
    },
    removeCustomSet(set) {
        this.customSets.splice(this.customSets.indexOf(set), 1)
        localStorage.setItem('customSets', JSON.stringify(this.customSets))
    },
    useCustomSet(set) {
        this.faces = [...set.list]; this.setName = set.name
    }

})
